import type { AccountType } from '@application/types';
import type { CountryCode, DogBreederApplicationStatus } from '@gql/graphql';
import type { Dayjs } from 'dayjs';
import type { LocationDescriptor } from 'history';
import type { MouseEventHandler } from 'react';

export interface MtApplicationPageInfoDetail {
  label: string;
  value: string;
}
export interface MtApplicationPageInfoDetailGroup {
  label: string;
  value: MtApplicationPageInfoDetail[];
}

export interface MtApplicationPageBreed {
  title: string;
  image: string;
}

export interface MtApplicationPagePerson {
  title: string;
  image: string;
  phoneNumber?: string;
  email?: string;
  agreementNumber?: string | null;
  country?: CountryCode | null;
  link?: LocationDescriptor;
  messageLink?: LocationDescriptor;
}

export interface MtApplicationPageAnimal {
  name: string | null;
  dateOfBirth: Dayjs | null;
}

export interface MtApplicationPageApplication {
  details: MtApplicationPageInfoDetailGroup[];
  breed: MtApplicationPageBreed;
  person: MtApplicationPagePerson;
  animal?: MtApplicationPageAnimal;
  status: DogBreederApplicationStatus;
  createdAt: string;
  differentCountryWarning?: string;
}

export interface MtApplicationPageData {
  loading: boolean;
  application: MtApplicationPageApplication | null;
  status?: string; // Don't show warning box on no status
  personType: AccountType;
  onBackClick: MouseEventHandler;
  onDeleteClick?: MouseEventHandler; // Don't show action on undefined
  onOwnClick?: MouseEventHandler; // Don't show action on undefined
  onPayClick?: MouseEventHandler; // Don't show action on undefined
  onMessagesClick?: MouseEventHandler; // Don't show action on undefined
  onCancelClick?: MouseEventHandler; // Don't show action on undefined
}

export interface MtApplicationPageProps extends MtApplicationPageData {}
